import ClosedEyeIcon from '@/assets/SVGs/icons/ClosedEyeIcon';
import OpenEyeIcon from '@/assets/SVGs/icons/OpenEyeIcon';
import PasswordIcon from '@/assets/SVGs/icons/PasswordIcon';
import UserEmailOrPhone from '@/assets/SVGs/icons/UserEmailOrPhone';
import AppButton from '@/components/ui/AppButton';
import AppInput from '@/components/ui/AppInput';
import FormErrorMessage from '@/components/ui/FormErrorMessage';
import { endpoints } from '@/services/endpoints';
import { axiosPostRequest } from '@/services/Request';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { z } from 'zod';
import sidebarLogo from '@/assets/images/sidebar-logo.png';
import { connectSocket } from '@/socket';

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const router = useNavigate();

  const { mutate: submitForm, isPending } = useMutation({
    mutationFn: (formData: LoginForm) => axiosPostRequest(endpoints.login, formData),
    onSuccess: data => {
      localStorage.setItem('token', data.token);
      Cookies.set('token', data.token);
      // Connect socket immediately after auth
      connectSocket();
      setTimeout(() => {
        router('/', { replace: true });
      }, 2000);

      toast.success('Login success you will be redirected to dashboard', {
        style: { boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.04)', width: 'auto' },
        autoClose: 5000,
        closeOnClick: true,
        draggable: true,
        theme: 'light',
      });
    },
    onError: (message: string) => {
      toast.error(message, {
        style: { boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.04)', width: 'auto' },
        autoClose: 5000,
        closeOnClick: true,
        draggable: true,
        theme: 'light',
      });
    },
  });

  type LoginForm = {
    email: string;
    password: string;
    phoneNumber: string;
  };

  const UserSchema = z.object({
    // email: z.string().email('Invalid email'),
    password: z.string().min(8, 'Password must be at least 8 characters'),
    phoneNumber: z.string(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>({ resolver: zodResolver(UserSchema) });

  function handleSubmitForm(data: LoginForm): void {
    submitForm(data);
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-coal-100 px-4">
      <ToastContainer />
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-coal-200 bg-white p-8 shadow-dropdown sm:p-10">
          {/* Logo */}
          <div className="mb-8 flex flex-col items-center">
            <img src={sidebarLogo} alt="Logo" className="mb-4 h-10" />
            <h1 className="text-2xl font-bold text-coal-900">Welcome Back</h1>
            <p className="mt-1.5 text-sm text-coal-400">Sign in to your admin dashboard</p>
          </div>

          <form onSubmit={handleSubmit(handleSubmitForm)} className="space-y-5">
            {/* <div>
              <label className="mb-1.5 block text-sm font-medium text-coal-700">Email</label>
              <AppInput
                type="email"
                {...register('email')}
                placeholder="you@example.com"
                icon={UserEmailOrPhone}
              />
              {errors.email && <FormErrorMessage message={errors.email.message} />}
            </div> */}
            <div>
              <label className="mb-1.5 block text-sm font-medium text-coal-700">Email</label>
              <AppInput
                type="phoneNumber"
                {...register('phoneNumber')}
                placeholder="you@example.com"
                icon={UserEmailOrPhone}
              />
              {errors.phoneNumber && <FormErrorMessage message={errors.phoneNumber.message} />}
            </div>
            <div>
              <label className="mb-1.5 block text-sm font-medium text-coal-700">Password</label>
              <AppInput
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                icon={PasswordIcon}
                {...register('password')}
                onIconClick={() => setShowPassword(!showPassword)}
                rightIcon={showPassword ? OpenEyeIcon : ClosedEyeIcon}
              />
              {errors.password && <FormErrorMessage message={errors.password.message} />}
            </div>
            <AppButton
              type="submit"
              loading={isPending}
              disabled={isPending}
              size="lg"
              fullWidth
              className="mt-2"
            >
              Sign In
            </AppButton>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-coal-400">
          © {new Date().getFullYear()} Kotobekia. All rights reserved.
        </p>
      </div>
    </div>
  );
}
